<template>
  <BCard class="min-h-[100vh]">
    <div class="flex w-full justify-between items-center">
      <div class="flex gap-[12px]">
        <BButton
          variant="primary"
          size="sm"
          class="rounded-[6px]"
          @click="$router.push('/komads/data-partner')"
        >
          <img
            class="w-[20px]"
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/arrow-left-2.svg"
            alt="arrow left"
          >
        </BButton>
        <div class="text-black font-semibold text-[24px]">
          Detail Partner Komads
        </div>
      </div>
    </div>

    <!-- Informasi Partner -->
    <div class="flex align-items-start justify-between mt-[24px] w-full">
      <div class="flex flex-col gap-[16px]">
        <div class="flex items-center">
          <div
            class="text-[#828282] text-base w-[200px] flex flex-row justify-between"
          >
            <p class="mb-0">
              Nama
            </p>
            <span class="mr-1">:</span>
          </div>
          <div class="text-black text-[16px]">
            {{ partnerData.full_name || '-' }}
          </div>
        </div>
        <div class="flex items-center">
          <div
            class="text-[#828282] text-base w-[200px] flex flex-row justify-between"
          >
            <p class="mb-0">
              Email
            </p>
            <span class="mr-1">:</span>
          </div>
          <div class="text-black text-[16px]">
            {{ partnerData.email || '-' }}
          </div>
        </div>
        <div class="flex items-center">
          <div
            class="text-[#828282] text-base w-[200px] flex flex-row justify-between"
          >
            <p class="mb-0">
              No HP
            </p>
            <span class="mr-1">:</span>
          </div>
          <div class="text-black text-[16px]">
            {{ partnerData.phone_number || '-' }}
          </div>
        </div>
        <div class="flex items-center">
          <div
            class="text-[#828282] text-base w-[200px] flex flex-row justify-between"
          >
            <p class="mb-0">
              Tanggal Registrasi
            </p>
            <span class="mr-1">:</span>
          </div>
          <div class="text-black text-[16px]">
            {{ DAY_MONTH_YEAR(partnerData.created_at) || '-' }}
          </div>
        </div>
        <div class="flex items-center">
          <div
            class="text-[#828282] text-base w-[200px] flex flex-row justify-between"
          >
            <p class="mb-0">
              Jenis Produk/Layanan
            </p>
            <span class="mr-1">:</span>
          </div>
          <div class="text-black text-[16px] capitalize">
            {{ partnerData.business_preferences.product_type.replace(/_/g, " ") || '-' }}
          </div>
        </div>
        <div class="flex items-center">
          <div
            class="text-[#828282] text-base w-[200px] flex flex-row justify-between"
          >
            <p class="mb-0">
              Landing Page
            </p>
            <span class="mr-1">:</span>
          </div>
          <a
            class="text-[16px]"
            :class="{
              'text-blue-500 underline': partnerData.business_preferences.product_content_link,
              'text-black': partnerData.business_preferences.product_content_link
            }"
            :href="partnerData.business_preferences.product_content_link || '#'"
            :target="partnerData.business_preferences.product_content_link ? '_blank' : '_self'"
          >
            {{ partnerData.business_preferences.product_content_link || '' }}
          </a>
        </div>
      </div>
      <img
        v-if="partnerData.user_badge"
        :src="partnerData.user_badge"
        alt="top-partner"
        class="w-[75px] h-auto me-[2%]"
      >
    </div>

    <!-- Area Chart -->
    <BRow class="my-[1.5rem]">
      <BCol
        lg="12"
      >
        <div class="flex items-center gap-[.5rem]">
          <span>Riwayat Pencapaian Spending</span>
          <span
            v-b-tooltip.hover.top="{
              title: 'Pencapaian spending bulanan dihitung berdasarkan akumulasi spending dari platform Meta, Google, dan TikTok yang dikumpulkan selama satu tahun',
              customClass: 'dark-tooltip double-text-tooltip'
            }"
            class="k-info-circle-1 text-[#08A0F7]"
          />
          <div class="w-[100px] ms-auto">
            <b-form-select
              v-model="selectedYear"
              :options="yearOptions"
              @change="getSpendAnalytic"
            />
          </div>
        </div>
      </BCol>
      <BCol
        lg="12"
      >
        <Chart
          :series="data.spendingPerYear"
          :loading="loading.analytic"
          :options="chartOptions"
        />
      </BCol>
    </BRow>

    <!-- Tabs CTWA dan Whitelist -->
    <div class="mt-[24px]">
      <BTabs
        v-model="activeTab"
        nav-class="border-bottom-0"
        active-nav-item-class="border-bottom-0 text-primary"
      >
        <BTab title="CTWA" />
        <BTab
          title="Whitelisted"
          active
        />
      </BTabs>
    </div>

    <div
      v-if="!ctwaData && activeTab === 0"
      class="flex flex-col items-center justify-center p-[24px] border rounded-[8px]"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/profile.svg"
        alt="Empty State"
        width="40"
        height="40"
        class="mb-2"
      >
      <p class="text-base font-medium">
        Data CTWA Partner ini belum tersedia
      </p>
    </div>
    <!-- CTWA -->
    <div
      v-if="activeTab === 0 && ctwaData"
      class="p-[16px] border rounded-[8px] "
    >
      <div class="flex justify-between items-center mb-2">
        <h3 class="text-black text-lg font-medium mb-0">
          Data CTWA Partner
        </h3>
        <BButton
          v-b-tooltip.hover.top="'Refresh data CTWA partner'"
          variant="outline-secondary"
          size="sm"
          class="rounded flex items-center gap-2"
          :disabled="loading.ctwa"
          @click="refreshCtwaData"
        >
          <b-spinner
            v-if="loading.ctwa"
            small
          />
          <img
            v-else
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/refresh-2.svg"
            alt="refresh"
            class="w-[16px] h-[16px]"
          >
        </BButton>
      </div>

      <!-- Statistics Cards -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-[8px]">
        <!-- Total Iklan CTWA Aktif -->
        <div class="p-[16px] border rounded-lg bg-white h-32">
          <div class="flex items-center gap-2 mb-2">
            <span class="text-[#828282] text-base">Total Iklan CTWA Aktif</span>
            <img
              v-b-tooltip.hover.topright="
                'Total iklan yang saat ini sedang berjalan dan tayang'
              "
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="info"
              class="ms-1 w-[16px] h-[16px]"
            >
          </div>
          <div class="text-black text-xl font-semibold">
            <b-spinner
              v-if="loading.ctwa"
              small
            />
            <span v-else>{{ ctwaData.total_active_ad }}</span>
          </div>
        </div>

        <!-- Total Pengeluaran -->
        <div class="p-[16px] border rounded-lg bg-white h-32">
          <div class="flex items-center gap-2 mb-2">
            <span class="text-[#828282] text-base">Total Pengeluaran</span>
            <img
              v-b-tooltip.hover.topright="
                'Total uang yang sudah kamu keluarkan untuk kampanye iklan'
              "
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="info"
              class="ms-1 w-[16px] h-[16px]"
            >
          </div>
          <div class="text-black text-xl font-semibold">
            <b-spinner
              v-if="loading.ctwa"
              small
            />
            <span v-else>{{ IDR(ctwaData.total_spend) }}</span>
          </div>
        </div>

        <!-- Total Impresi -->
        <div class="p-[16px] border rounded-lg bg-white h-32">
          <div class="flex items-center gap-2 mb-2">
            <span class="text-[#828282] text-base">Total Impresi</span>
            <img
              v-b-tooltip.hover.topright="
                'Total iklan kamu ditampilkan di layar penonton'
              "
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="info"
              class="ms-1 w-[16px] h-[16px]"
            >
          </div>
          <div class="text-black text-xl font-semibold">
            <b-spinner
              v-if="loading.ctwa"
              small
            />
            <span v-else>{{ formatNumber(ctwaData.total_impression) }}</span>
          </div>
        </div>

        <!-- Total Klik WA -->
        <div class="p-[16px] border rounded-lg bg-white h-32">
          <div class="flex items-center gap-2 mb-2">
            <span class="text-[#828282] text-base">Total Klik WA</span>
            <img
              v-b-tooltip.hover.topright="
                'Total klik pada iklan yang langsung membuka WhatsApp'
              "
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="info"
              class="ms-1 w-[16px] h-[16px]"
            >
          </div>
          <div class="text-black text-xl font-semibold">
            <b-spinner
              v-if="loading.ctwa"
              small
            />
            <span v-else>{{ formatNumber(ctwaData.total_click) }}</span>
          </div>
        </div>

        <!-- Rata Rata Rasio Klik -->
        <div class="p-[16px] border rounded-lg bg-white h-32">
          <div class="flex items-center gap-2 mb-2">
            <span class="text-[#828282] text-base">Rata Rata Rasio Klik</span>
            <img
              v-b-tooltip.hover.topright="
                'Rata-rata persentase klik iklan dibandingkan dengan total impresi'
              "
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="info"
              class="ms-1 w-[16px] h-[16px]"
            >
          </div>
          <div class="text-black text-xl font-semibold">
            <b-spinner
              v-if="loading.ctwa"
              small
            />
            <span
              v-else
            >{{ formatPercentage(ctwaData.total_click_ratio) }}%</span>
          </div>
        </div>

        <!-- Rata Rata Biaya per WA -->
        <div class="p-[16px] border rounded-lg bg-white h-32">
          <div class="flex items-center gap-2 mb-2">
            <span class="text-[#828282] text-base">Rata Rata Biaya per-WA</span>
            <img
              v-b-tooltip.hover.topright="
                'Rata-rata biaya yang kamu keluarkan untuk setiap klik yang membuka Whatsapp'
              "
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="info"
              class="ms-1 w-[16px] h-[16px]"
            >
          </div>
          <div class="text-black text-xl font-semibold">
            <b-spinner
              v-if="loading.ctwa"
              small
            />
            <span v-else>{{ IDR(ctwaData.total_cost_per_click) }}</span>
          </div>
        </div>
      </div>

      <!-- Content Sections -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Onboard Section -->
        <div class="p-[16px] border rounded-lg bg-white max-h-40">
          <h3 class="text-black text-lg font-medium mb-1">
            Onboard
          </h3>
          <div class="w-full">
            <ol class="list-disc pl-2 space-y-1">
              <li>
                <span class="text-base">Facebook : </span>
                <b-spinner
                  v-if="loading.ctwa"
                  small
                />
                <span v-else>{{
                  ctwaData.onboard_data.facebook_name || '-'
                }}</span>
              </li>
              <li>
                <span class="text-base">Terhubung : </span>
                <b-spinner
                  v-if="loading.ctwa"
                  small
                />
                <span v-else>
                  {{
                    ctwaData.onboard_data.connect_date
                      ? DAY_MONTH_YEAR(ctwaData.onboard_data.connect_date)
                      : '-'
                  }}
                </span>
              </li>
            </ol>
          </div>
        </div>

        <!-- Iklan CTWA Partner Section -->
        <div class="p-[16px] border rounded-lg bg-white max-h-40">
          <h3 class="text-black text-lg font-medium mb-1">
            Iklan CTWA Partner
          </h3>
          <div class="w-full">
            <ol class="list-disc pl-2 space-y-1">
              <li>
                <span
                  class="text-[#828282] text-base w-[120px]"
                >Iklan CTWA Pertama :
                </span>
                <b-spinner
                  v-if="loading.ctwa"
                  small
                />
                <span v-else>
                  {{
                    ctwaData.ctwa_ad_info.first_ctwa_ad
                      ? DAY_MONTH_YEAR(ctwaData.ctwa_ad_info.first_ctwa_ad)
                      : '-'
                  }}
                </span>
              </li>
              <li>
                <span
                  class="text-[#828282] text-base w-[120px]"
                >Iklan CTWA Terakhir :
                </span>
                <b-spinner
                  v-if="loading.ctwa"
                  small
                />
                <span v-else>
                  {{
                    ctwaData.ctwa_ad_info.last_ctwa_ad
                      ? DAY_MONTH_YEAR(ctwaData.ctwa_ad_info.last_ctwa_ad)
                      : '-'
                  }}
                </span>
              </li>
              <li>
                <span
                  class="text-[#828282] text-base w-[120px]"
                >Total Iklan CTWA :
                </span>
                <b-spinner
                  v-if="loading.ctwa"
                  small
                />
                <span v-else>{{ ctwaData.ctwa_ad_info.total_ctwa_ad }}</span>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- Total Spending -->
    <div v-if="activeTab === 1">
      <div class="mb-[24px] rounded-[8px]">
        <!-- Platform Preferences -->
        <div>
          <div class="flex items-center gap-[8px] mb-[8px]">
            <div class="flex w-[200px] justify-between">
              <span class="text-[#828282]">Preferensi Platform</span>
              <span class="text-[#828282]">:</span>
            </div>
            <div
              v-for="platform in platformPreferences"
              :key="platform"
            >
              <img
                v-if="platform === 'meta'"
                src="https://storage.googleapis.com/komerce/komads-meta/meta.svg"
                alt="Google"
                width="16"
                height="16"
              >
              <img
                v-else-if="platform === 'google'"
                src="https://storage.googleapis.com/komerce/komads-meta/google.svg"
                alt="Google"
                width="16"
                height="16"
              >
              <img
                v-else-if="platform === 'tiktok'"
                src="https://storage.googleapis.com/komerce/komads-meta/tiktok.svg"
                alt="Google"
                width="16"
                height="16"
              >
            </div>
          </div>
          <!-- Fee Top Up -->
          <div class="flex items-center gap-[8px] mb-[8px]">
            <div class="flex w-[200px] justify-between">
              <span class="text-[#828282]">Fee Top Up</span>
              <span class="text-[#828282]">:</span>
            </div>
            <div
              v-for="fee_topup in feeTopups"
              :key="fee_topup.id"
            >
              <span
                v-if="fee_topup.platform_name === 'meta'"
                class="text-black text-sm flex flex-row bg-[#FFECE9] rounded p-0.5"
              ><img
                src="https://storage.googleapis.com/komerce/komads-meta/meta.svg"
                alt="Google"
                width="16"
                height="16"
              >{{ fee_topup.fee_topup }}%</span>
              <span
                v-else-if="fee_topup.platform_name === 'google'"
                class="text-black text-sm flex flex-row bg-[#FFECE9] rounded p-0.5"
              >
                <img
                  src="https://storage.googleapis.com/komerce/komads-meta/google.svg"
                  alt="Google"
                  width="16"
                  height="16"
                >
                {{ fee_topup.fee_topup }}%
              </span>
              <span
                v-else-if="fee_topup.platform_name === 'tiktok'"
                class="text-black text-sm flex flex-row bg-[#FFECE9] rounded p-0.5"
              >
                <img
                  src="https://storage.googleapis.com/komerce/komads-meta/tiktok.svg"
                  alt="TikTok"
                  width="16"
                  height="16"
                >
                {{ fee_topup.fee_topup }}%</span>
            </div>
          </div>

          <!-- Platform used -->
          <div class="flex items-center gap-[8px]">
            <div class="flex w-[200px] justify-between">
              <span
                class="text-[#828282]"
              >Platform yang digunakan</span>
              <span class="text-[#828282]">:</span>
            </div>
            <div
              v-for="platform in platformUsed"
              :key="platform"
            >
              <img
                v-if="platform === 'meta'"
                src="https://storage.googleapis.com/komerce/komads-meta/meta.svg"
                alt="Google"
                width="16"
                height="16"
              >
              <img
                v-else-if="platform === 'google'"
                src="https://storage.googleapis.com/komerce/komads-meta/google.svg"
                alt="Google"
                width="16"
                height="16"
              >
              <img
                v-else-if="platform === 'tiktok'"
                src="https://storage.googleapis.com/komerce/komads-meta/tiktok.svg"
                alt="Google"
                width="16"
                height="16"
              >
              <span
                v-else
                class="text-black text-sm"
              >-</span>
            </div>
          </div>
        </div>
      </div>

      <div class="border rounded-[8px] mt-2 p-[16px]">
        <div class="bg-[#F8F8F8] p-1 rounded">
          <div class="flex justify-between">
            <div class="flex items-center gap-[8px]">
              <img
                alt="usd"
                src="https://storage.googleapis.com/komerce/assets/icons/usd-coin-green.svg"
                width="16"
                height="16"
              >
              <span class="font-medium">Total Spending</span>
              <img
                v-b-tooltip.hover.topright="
                  'Total spending dari semua akun whitelisted yang kamu miliki'
                "
                src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                alt="info"
                class="w-[16px] h-[16px]"
              >
            </div>
            <div
              class="month-picker w-[130px] border flex justify-between rounded items-center px-[5px] [&_.month-year-label]:py-[11px] [&_.month-year-label]:cursor-pointer [&_.month-year-label]:w-[130px] [&_.month-picker-wrapper]:-translate-x-[6px] [&_.month-picker-wrapper]:!min-w-0 [&_.date-popover]:min-w-[200px] [&_.date-popover]:!-translate-x-[calc(50%-6px)] [&_.date-popover]:!translate-y-4 right-0 z-10 bg-white"
            >
              <MonthlyPicker
                v-model="filterMonth"
                :month-labels="monthlabel"
                date-format="MMM YYYY"
                style="width: 90px;"
                input-class="border-0 w-[100px] h-full font-semibold"
                :clear-option="false"
                :disabled="loading.data"
                :alignment="'center'"
                :selected-background-color="'#F95031'"
                :max="moment()"
              />
              <b-spinner
                v-if="loading.data"
                class="mr-[7px]"
                small
              />
              <span
                v-else
                class="k-calendar text-3xl"
              />
            </div>
          </div>
          <div class="mt-[8px]">
            <div class="flex flex-row items-center mb-1">
              <h1 class="text-black text-[32px] font-semibold mb-0">
                {{ IDR(totalSpending) }}
              </h1>
            </div>
            <div class="text-[#828282] text-base">
              Bulan lalu: {{ IDR(totalSpendingLastMonth) }}
            </div>
          </div>

          <div class="platform-cards">
            <div
              v-if="totalSpendingPlatform"
              class="grid grid-cols-1 md:grid-cols-3 gap-[16px] mt-2"
            >
              <div
                v-for="platform in totalSpendingPlatform"
                :key="platform.platform_name"
              >
                <PlatformCard
                  :platform="platform.platform_name"
                  :total-spending="IDR(platform.total_spend)"
                  :last-update-date="platform.last_updated_at"
                  :status="platform.account_request_status"
                  :partner-id="platform.user_id"
                  :request-id="platform.account_request_id"
                  :expired-at="platform.expired_at"
                  :is-gamification-claim="platform.gamification_claim ? platform.gamification_claim.is_gamification_claim : false"
                />
              </div>
            </div>

            <div
              v-else
              class="grid grid-cols-1 md:grid-cols-3 gap-[16px] mt-2"
            >
              <div
                v-for="platform in ['meta', 'google', 'tiktok']"
                :key="platform"
              >
                <PlatformCard
                  :key="platform"
                  :platform="platform"
                  :last-update-date="'-'"
                  :total-spending="IDR(0)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BCard>
</template>

<!-- eslint-disable camelcase -->
<script>

import { DAY_MONTH_YEAR, LABELMONTH, MONTH_YEAR } from '@/libs/filterDate'
import MonthlyPicker from 'vue-monthly-picker'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import moment from 'moment'
import { newAxiosIns } from '@/libs/axios'
import { IDR } from '@/libs/currency'
import PlatformCard from './PlatformCard.vue'
import Chart from '../../components/Chart.vue'
import { chartOptions } from '../config'

export default {
  components: {
    MonthlyPicker,
    PlatformCard,
    Chart,
  },
  data() {
    const currentYear = new Date().getFullYear()
    return {
      selectedYear: String(currentYear),
      yearOptions: Array.from({ length: 10 }, (_, i) => ({
        value: String(currentYear - i),
        text: String(currentYear - i),
      })),
      DAY_MONTH_YEAR,
      IDR,
      moment,
      activeTab: 0,

      partnerData: null,

      loading: {
        data: false,
        ctwa: false,
        analytic: false,
      },

      ctwaData: null,
      analyticData: null,

      totalSpending: 0,
      totalSpendingLastMonth: 0,

      platformPreferences: [],
      feeTopups: [],
      platformUsed: [],
      totalSpendingPlatform: [],

      monthlabel: LABELMONTH,
      filterMonth: moment().format('YYYY-MM'),
      selectedFeePercentage: 0,
      feePercentageOptions: [
        { value: 3, text: '3%' },
        { value: 3.5, text: '3.5%' },
        { value: 4, text: '4%' },
        { value: 4.5, text: '4.5%' },
        { value: 5, text: '5%' },
      ],

      selectedAccount: {},

      data: {
        spendingPerYear: [],
      },
      chartOptions,
    }
  },
  watch: {
    filterMonth: {
      handler() {
        this.getWhitelistInfo()
      },
    },
  },
  mounted() {
    this.getPartnerDetail()
    this.getSpendAnalytic()
    this.getCtwaInfo()
    this.getWhitelistInfo()
  },
  methods: {
    async getPartnerDetail() {
      this.loading.data = true
      const { id } = this.$route.params
      try {
        const { data } = await newAxiosIns.get(
          `komads/api/v1/admin/partners/${id}/detail`,
        )

        this.partnerData = data.data
        this.selectedFeePercentage = data.data.fee_topup
      } catch {
        // Failed to fetch partner data - component will show empty state
      } finally {
        this.loading.data = false
      }
    },

    async getSpendAnalytic() {
      this.loading.analytic = true
      const { id } = this.$route.params
      try {
        const { data } = await newAxiosIns.get(
          `komads/api/v1/admin/partners/${id}/spend_analytic_monthly`,
          {
            params: {
              year: this.selectedYear,
            },
          },
        )

        this.analyticData = data.data
        const spendingData = data.data.map(item => ({
          x: item.month,
          y: item.total_spending,
        }))
        const STEP = 100000000
        const maxSpending = Math.max(...spendingData.map(i => i.y))
        this.data.spendingPerYear = [
          {
            name: 'Total Spending',
            data: spendingData,
          },
        ]
        const months = data.data.map(item => item.month)
        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            ...this.chartOptions.xaxis,
            categories: months,
            labels: {
              formatter: value => value?.slice(0, 3),
            },
          },
          yaxis: {
            ...this.chartOptions.yaxis,
            max: maxSpending % STEP === 0
              ? maxSpending + STEP
              : undefined,
          },
          tooltip: {
            custom({
              series, seriesIndex, dataPointIndex, w,
            }) {
              const value = series[seriesIndex][dataPointIndex]
              const item = data.data[dataPointIndex]

              return `
                <div style="display: flex; align-items: center; gap: .5rem; color: white; background-color: black; padding: 1rem;">
                  ${item.user_badge ? `<img src="${item.user_badge}" style="width: 40px; height: auto" />` : ''}
                  <p style="margin: 0">
                    <span style="margin-bottom: .5rem">Total Spending:</span>
                    <br>
                    <span style="font-weight: 600">${IDR(value)}</span>
                  </p>
                </div>
              `
            },
          },
        }
      } catch {
        // Failed to fetch partner data - component will show empty state
      } finally {
        this.loading.analytic = false
      }
    },

    /**
     * Fetch CTWA information for the partner
     * Called when CTWA tab is selected or component is mounted
     */
    async getCtwaInfo() {
      this.loading.ctwa = true
      const { id } = this.$route.params
      try {
        const { data } = await newAxiosIns.get(
          `komads/api/v1/admin/partners/${id}/ctwa_info`,
        )

        this.ctwaData = data.data
      } catch {
        // Failed to fetch CTWA data - component will show empty state
        this.ctwaData = null
      } finally {
        this.loading.ctwa = false
      }
    },

    // Refresh CTWA data with loading state
    async refreshCtwaData() {
      this.loading.ctwa = true
      try {
        await this.getCtwaInfo()
        this.$toast_success({
          message: 'Data CTWA berhasil diperbarui',
        })
      } catch {
        this.$toast_error({
          message: 'Gagal memperbarui data CTWA',
        })
      } finally {
        this.loading.ctwa = false
      }
    },

    // Format number with thousands separator (Indonesian format)
    formatNumber(value) {
      return new Intl.NumberFormat('id-ID', {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(value)
    },

    // Format percentage with 2 decimal places
    formatPercentage(value) {
      return parseFloat(value).toFixed(2)
    },

    async getWhitelistInfo() {
      const { id } = this.$route.params
      try {
        const { data } = await newAxiosIns.get(
          `komads/api/v1/admin/partners/${id}/whitelist_info`,
          {
            params: {
              month: MONTH_YEAR(this.filterMonth),
            },
          },
        )

        const {
          total_spending, total_last_month_spending, platform_preferences, fee_topups, platform_used, total_spend_platform,
        } = data.data

        this.totalSpending = total_spending
        this.totalSpendingLastMonth = total_last_month_spending
        this.feeTopups = fee_topups
        this.totalSpendingPlatform = total_spend_platform
        this.platformUsed = !platform_used ? [] : platform_used.split(',')
        this.platformPreferences = !platform_preferences ? [] : platform_preferences.split(',')
      } catch {
        this.$toast_error({
          message: 'Gagal mengambil data whitelisted',
        })
      } finally {
        this.loading.data = false
      }
    },
  },
}
</script>

<style scoped>
.nav-tabs .nav-link.active {
  color: #7367f0;
  font-weight: 600;
  background-color: transparent;
  border-bottom: 2px solid #7367f0 !important;
  border-color: transparent transparent #7367f0 transparent;
}

.nav-tabs .nav-link {
  color: #828282;
}

/* Styling untuk fee top up popover */
::v-deep .fee-top-up-popover {
  max-width: 280px;
}

::v-deep .fee-top-up-popover .popover-header {
  background-color: #f8f8f8;
  border-bottom: 1px solid #e2e2e2;
  font-size: 14px;
  padding: 8px 12px;
}

::v-deep .fee-top-up-popover .popover-body {
  padding: 0;
}

::v-deep .date-popover {
  z-index: 9999 !important;
}
</style>
